import { AppEntities } from "../../../../config/entities";
import React from "react";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";
import { IListViewField } from "../../../Shared/ILIstViewField";

const IncomeItemList = () => {
    const fields: IListViewField[] = [
    ];

    return (
        <>
            <NewCatalogListView fields={fields} entity={AppEntities.IncomeItem} />
        </>
    );
}

export default IncomeItemList;